module.exports = __webpack_public_path__ + "img/b_Biofer_front_2.96e56e23.jpeg";